import * as React from 'react';
/**
 *
 * Original name: notification
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1245
 *
 */
export const NotificationFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m17.608 12.971-.329-.219a1.746 1.746 0 0 1-.779-1.457v-1.67c0-1.094 0-2.332-.563-3.336C15.26 5.084 13.973 4.5 12 4.5c-1.973 0-3.26.585-3.937 1.787C7.5 7.292 7.5 8.531 7.5 9.624v1.672a1.746 1.746 0 0 1-.78 1.454l-.328.219A4.241 4.241 0 0 0 4.5 16.507v.993H10a1.857 1.857 0 0 0 2 2 1.857 1.857 0 0 0 2-2h5.5v-.993a4.24 4.24 0 0 0-1.892-3.536Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
